<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="4" :sm="12">
            <a-form-item label="月份">
              <a-select placeholder="请选择" v-model="queryParam.month">
                <a-select-option value="01">1月</a-select-option>
                <a-select-option value="02">2月</a-select-option>
                <a-select-option value="03">3月</a-select-option>
                <a-select-option value="04">4月</a-select-option>
                <a-select-option value="05">5月</a-select-option>
                <a-select-option value="06">6月</a-select-option>
                <a-select-option value="07">7月</a-select-option>
                <a-select-option value="08">8月</a-select-option>
                <a-select-option value="09">9月</a-select-option>
                <a-select-option value="10">10月</a-select-option>
                <a-select-option value="11">11月</a-select-option>
                <a-select-option value="12">12月</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="10">
            <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;height:40px;">
        <span style="float:right; ">金额单位：万元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="itemSlot" slot-scope="item">
          <span v-if="item.level===1">{{item.text}}</span>
          <span v-if="item.level===2" style="margin-left:0px;">{{item.text}}</span>
          <span v-if="item.level===3" style="margin-left:45px;">{{item.text}}</span>
        </template>
      </a-table>

    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { toDecimal } from '@/utils/util'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction, postAction } from '@/api/manage'
  import {getDictItemsFromCache} from '@/api/api'

  export default {
    name: 'BizLifeReport',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
    },
    data () {
      return {
        description: '财产险报表', //所有机构财产险
        disableMixinCreated: true,
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'项目',
            className: 'column-text',
            scopedSlots: {customRender: 'itemSlot'}
          },
          {
            title:'德州',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03A08A04Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03A08A04Amount',
              }]
          },
          {
            title:'枣庄',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03A08A07Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03A08A07Amount',
              }]
          },
          {
            title:'临沂',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03A08A12Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03A08A12Amount',
              }]
          },
          {
            title:'淄博',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03A08A03Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03A08A03Amount',
              }]
          },
          {
            title:'青岛',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03A08A13Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03A08A13Amount',
              }]
          },
          {
            title:'滨城',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03A08A08Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03A08A08Amount',
              }]
          },
          {
            title:'总部',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03Amount',
              }]
          },
          {
            title:'合计',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'HJPremium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'HJAmount',
              }]
          },
        ],
        url: {
          list: "/bms/regulatoryReport/productReport",
        },
      }
    },
    created() {
    },
    methods: {
      searchQuery(){
        if(this.queryParam.month){
          this.loadData()
        }
      },
      loadData() {
        this.loading = true;

        let year = new Date().getFullYear()
        let param = {year: year, month: this.queryParam.month}
        this.dataSource = this.transferData();
        /*以invoice_time字段进行比较，即财务开票日期归属到不同月份*/
        postAction(this.url.list, param).then((res) => {
          if (res.success) {
            this.dataSource = this.transferData(res.result);
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },

      // 把后台返回数据进行格式转换
      transferData(resultData){
        if(!resultData){
          return;
        }

        // 总部寿险数据，顺序是确定的, level是报表中的级次，显示用
        let productData = [
          {text:'1.企业财产保险',level:1, insuranceTypeCode:'0', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'2.家庭财产保险',level:2, insuranceTypeCode:'1', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'其中：投资型家财险',level:3, insuranceTypeCode:'14', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'3.机动车辆保险',level:1, insuranceTypeCode:'2', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'其中：交强险',level:3, insuranceTypeCode:'15', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'4.工程保险',level:1, insuranceTypeCode:'3', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'5.责任保险',level:1, insuranceTypeCode:'4', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'6.信用保险',level:1, insuranceTypeCode:'5', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'7.保证保险',level:1, insuranceTypeCode:'6', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'其中：机动车辆消费贷款保证保险',level:3, insuranceTypeCode:'16', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'其中：个人贷款抵押房屋保证保险',level:3, insuranceTypeCode:'17', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'8.船舶保险',level:1, insuranceTypeCode:'7', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'9.货物运输保险',level:1, insuranceTypeCode:'8', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'10.特殊风险保险',level:1, insuranceTypeCode:'9', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'11.农业保险',level:1, insuranceTypeCode:'10', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'12.健康险',level:1, insuranceTypeCode:'11', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'其中：投资型健康险',level:3, insuranceTypeCode:'18', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'13.意外伤害保险',level:1, insuranceTypeCode:'12', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'其中：投资型意外险',level:3, insuranceTypeCode:'19', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'14.其他险',level:1, insuranceTypeCode:'13', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00},
          {text:'总计',level:3, insuranceTypeCode:'ZJ', A03A08A04Premium:0.00, A03A08A04Amount:0.00,A03A08A07Premium:0.00, A03A08A07Amount:0.00,A03A08A08Amount:0.00,A03A08A08Premium:0.00, A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00, A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00, HJPremium:0.00,HJAmount:0.00}];

        // 赋值结果集, 一次赋值各组织机构
        for(let i=0; i<resultData.length; i++){
          let money = resultData[i];
          for(let j=0; j<productData.length; j++){
            if(productData[j].insuranceTypeCode == money.insuranceTypeCode){
              productData[j][money.orgCode+'Premium'] = money.cleanPremium
              productData[j][money.orgCode+'Amount'] = money.invoiceAmount
              break; //退出内层循环
            }
          }
        }

        //计算求和, 根据报表公司直接求和
        //2=2+3
        productData[1].A03Premium = productData[1].A03Premium + productData[2].A03Premium
        productData[1].A03Amount = productData[1].A03Amount + productData[2].A03Amount
        productData[1].A03A08A03Premium = productData[1].A03A08A03Premium + productData[2].A03A08A03Premium
        productData[1].A03A08A03Amount = productData[1].A03A08A03Amount + productData[2].A03A08A03Amount
        productData[1].A03A08A12Premium = productData[1].A03A08A12Premium + productData[2].A03A08A12Premium
        productData[1].A03A08A12Amount = productData[1].A03A08A12Amount + productData[2].A03A08A12Amount
        productData[1].A03A08A13Premium = productData[1].A03A08A13Premium + productData[2].A03A08A13Premium
        productData[1].A03A08A13Amount = productData[1].A03A08A13Amount + productData[2].A03A08A13Amount
        productData[1].A03A08A04Premium = productData[1].A03A08A04Premium + productData[2].A03A08A04Premium
        productData[1].A03A08A04Amount = productData[1].A03A08A04Amount + productData[2].A03A08A04Amount
        productData[1].A03A08A07Premium = productData[1].A03A08A07Premium + productData[2].A03A08A07Premium
        productData[1].A03A08A07Amount = productData[1].A03A08A07Amount + productData[2].A03A08A07Amount
        productData[1].A03A08A08Premium = productData[1].A03A08A08Premium + productData[2].A03A08A08Premium
        productData[1].A03A08A08Amount = productData[1].A03A08A08Amount + productData[2].A03A08A08Amount

        //4=4+5
        productData[3].A03Premium = productData[3].A03Premium + productData[4].A03Premium
        productData[3].A03Amount = productData[3].A03Amount + productData[4].A03Amount
        productData[3].A03A08A03Premium = productData[3].A03A08A03Premium + productData[4].A03A08A03Premium
        productData[3].A03A08A03Amount = productData[3].A03A08A03Amount + productData[4].A03A08A03Amount
        productData[3].A03A08A12Premium = productData[3].A03A08A12Premium + productData[4].A03A08A12Premium
        productData[3].A03A08A12Amount = productData[3].A03A08A12Amount + productData[4].A03A08A12Amount
        productData[3].A03A08A3Premium = productData[3].A03A08A13Premium + productData[4].A03A08A13Premium
        productData[3].A03A08A13Amount = productData[3].A03A08A13Amount + productData[4].A03A08A13Amount
        productData[3].A03A08A04Premium = productData[3].A03A08A04Premium + productData[4].A03A08A04Premium
        productData[3].A03A08A04Amount = productData[3].A03A08A04Amount + productData[4].A03A08A04Amount
        productData[3].A03A08A07Premium = productData[3].A03A08A07Premium + productData[4].A03A08A07Premium
        productData[3].A03A08A07Amount = productData[3].A03A08A07Amount + productData[4].A03A08A07Amount
        productData[3].A03A08A08Premium = productData[3].A03A08A08Premium + productData[4].A03A08A08Premium
        productData[3].A03A08A08Amount = productData[3].A03A08A08Amount + productData[4].A03A08A08Amount

        //9＝9+10+11
        productData[8].A03Premium = toDecimal(productData[8].A03Premium + productData[9].A03Premium + productData[10].A03Premium)
        productData[8].A03Amount = toDecimal(productData[8].A03Amount + productData[9].A03Amount + productData[10].A03Amount)
        productData[8].A03A08A03Premium = toDecimal(productData[8].A03A08A03Premium + productData[9].A03A08A03Premium + productData[10].A03A08A03Premium)
        productData[8].A03A08A03Amount = toDecimal(productData[8].A03A08A03Amount + productData[9].A03A08A03Amount + productData[10].A03A08A03Amount)
        productData[8].A03A08A12Premium = toDecimal(productData[8].A03A08A12Premium + productData[9].A03A08A12Premium + productData[10].A03A08A12Premium)
        productData[8].A03A08A12Amount = toDecimal(productData[8].A03A08A12Amount + productData[9].A03A08A12Amount + productData[10].A03A08A12Amount)
        productData[8].A03A08A13Premium = toDecimal(productData[8].A03A08A13Premium + productData[9].A03A08A13Premium + productData[10].A03A08A13Premium)
        productData[8].A03A08A13Amount = toDecimal(productData[8].A03A08A13Amount + productData[9].A03A08A13Amount + productData[10].A03A08A13Amount)
        productData[8].A03A08A04Premium = toDecimal(productData[8].A03A08A04Premium + productData[9].A03A08A04Premium + productData[10].A03A08A04Premium)
        productData[8].A03A08A04Amount = toDecimal(productData[8].A03A08A04Amount + productData[9].A03A08A04Amount + productData[10].A03A08A04Amount)
        productData[8].A03A08A07Premium = toDecimal(productData[8].A03A08A07Premium + productData[9].A03A08A07Premium + productData[10].A03A08A07Premium)
        productData[8].A03A08A07Amount = toDecimal(productData[8].A03A08A07Amount + productData[9].A03A08A07Amount + productData[10].A03A08A07Amount)
        productData[8].A03A08A13Premium = toDecimal(productData[8].A03A08A08Premium + productData[9].A03A08A08Premium + productData[10].A03A08A08Premium)
        productData[8].A03A08A13Amount = toDecimal(productData[8].A03A08A08Amount + productData[9].A03A08A08Amount + productData[10].A03A08A08Amount)

        //16=16+17
        productData[15].A03Premium = productData[15].A03Premium + productData[16].A03Premium
        productData[15].A03Amount = productData[15].A03Amount + productData[16].A03Amount
        productData[15].A03A08A03Premium = productData[15].A03A08A03Premium + productData[16].A03A08A03Premium
        productData[15].A03A08A03Amount = productData[15].A03A08A03Amount + productData[16].A03A08A03Amount
        productData[15].A03A08A12Premium = productData[15].A03A08A12Premium + productData[16].A03A08A12Premium
        productData[15].A03A08A12Amount = productData[15].A03A08A12Amount + productData[16].A03A08A12Amount
        productData[15].A03A08A13Premium = productData[15].A03A08A13Premium + productData[16].A03A08A13Premium
        productData[15].A03A08A13Amount = productData[15].A03A08A13Amount + productData[16].A03A08A13Amount
        productData[15].A03A08A04Premium = productData[15].A03A08A04Premium + productData[16].A03A08A04Premium
        productData[15].A03A08A04Amount  = productData[15].A03A08A04Amount  + productData[16].A03A08A04Amount
        productData[15].A03A08A07Premium = productData[15].A03A08A07Premium + productData[16].A03A08A07Premium
        productData[15].A03A08A07Amount  = productData[15].A03A08A07Amount  + productData[16].A03A08A07Amount
        productData[15].A03A08A08Premium = productData[15].A03A08A08Premium + productData[16].A03A08A08Premium
        productData[15].A03A08A08Amount  = productData[15].A03A08A08Amount  + productData[16].A03A08A08Amount

        //18=18+19
        productData[17].A03Premium = productData[17].A03Premium + productData[18].A03Premium
        productData[17].A03Amount = productData[17].A03Amount + productData[18].A03Amount
        productData[17].A03A08A03Premium = productData[17].A03A08A03Premium + productData[18].A03A08A03Premium
        productData[17].A03A08A03Amount = productData[17].A03A08A03Amount + productData[18].A03A08A03Amount
        productData[17].A03A08A12Premium = productData[17].A03A08A12Premium + productData[18].A03A08A12Premium
        productData[17].A03A08A12Amount = productData[17].A03A08A12Amount + productData[18].A03A08A12Amount
        productData[17].A03A08A13Premium = productData[17].A03A08A13Premium + productData[18].A03A08A13Premium
        productData[17].A03A08A13Amount = productData[17].A03A08A13Amount + productData[18].A03A08A13Amount
        productData[17].A03A08A04Premium = productData[17].A03A08A04Premium + productData[18].A03A08A04Premium
        productData[17].A03A08A04Amount  = productData[17].A03A08A04Amount  + productData[18].A03A08A04Amount
        productData[17].A03A08A07Premium = productData[17].A03A08A07Premium + productData[18].A03A08A07Premium
        productData[17].A03A08A07Amount  = productData[17].A03A08A07Amount  + productData[18].A03A08A07Amount
        productData[17].A03A08A08Premium = productData[17].A03A08A08Premium + productData[18].A03A08A08Premium
        productData[17].A03A08A08Amount  = productData[17].A03A08A08Amount  + productData[18].A03A08A08Amount

        //计算总计
        for(let i=0; i<productData.length-1; i++){
          if(i== 2 || i==4 || i==9 || i==10 || i==16 || i==18 ){ // 子项不能再累计
            continue
          }
          productData[20].A03Premium += productData[i].A03Premium
          productData[20].A03Amount += productData[i].A03Amount
          productData[20].A03A08A03Premium += productData[i].A03A08A03Premium
          productData[20].A03A08A03Amount += productData[i].A03A08A03Amount
          productData[20].A03A08A12Premium += productData[i].A03A08A12Premium
          productData[20].A03A08A12Amount += productData[i].A03A08A12Amount
          productData[20].A03A08A13Premium += productData[i].A03A08A13Premium
          productData[20].A03A08A13Amount += productData[i].A03A08A13Amount
          productData[20].A03A08A04Premium += productData[i].A03A08A04Premium
          productData[20].A03A08A04Amount += productData[i].A03A08A04Amount
          productData[20].A03A08A07Premium += productData[i].A03A08A07Premium
          productData[20].A03A08A07Amount += productData[i].A03A08A07Amount
          productData[20].A03A08A08Premium += productData[i].A03A08A08Premium
          productData[20].A03A08A08Amount += productData[i].A03A08A08Amount
        }

        // 计算合计数
        for(let i=0; i<productData.length; i++){
          productData[i].HJPremium = productData[i].A03Premium + productData[i].A03A08A03Premium + productData[i].A03A08A12Premium+ productData[i].A03A08A13Premium + productData[i].A03A08A04Premium + productData[i].A03A08A07Premium + productData[i].A03A08A08Premium
          productData[i].HJAmount = productData[i].A03Amount + productData[i].A03A08A03Amount + productData[i].A03A08A12Amount+ productData[i].A03A08A13Amount + productData[i].A03A08A04Amount + productData[i].A03A08A07Amount + productData[i].A03A08A08Amount
        }

        // 保留2位小数
        for(let i=0; i<productData.length; i++){
          productData[i].A03Premium =  toDecimal(productData[i].A03Premium)
          productData[i].A03Amount =  toDecimal(productData[i].A03Amount)
          productData[i].A03A08A03Premium =  toDecimal(productData[i].A03A08A03Premium)
          productData[i].A03A08A03Amount =  toDecimal(productData[i].A03A08A03Amount)
          productData[i].A03A08A12Premium =  toDecimal(productData[i].A03A08A12Premium)
          productData[i].A03A08A12Amount =  toDecimal(productData[i].A03A08A12Amount)
          productData[i].A03A08A13Premium =  toDecimal(productData[i].A03A08A13Premium)
          productData[i].A03A08A13Amount =  toDecimal(productData[i].A03A08A13Amount)
          productData[i].A03A08A04Premium =  toDecimal(productData[i].A03A08A04Premium)
          productData[i].A03A08A04Amount =  toDecimal(productData[i].A03A08A04Amount)
          productData[i].A03A08A07Premium =  toDecimal(productData[i].A03A08A07Premium)
          productData[i].A03A08A07Amount =  toDecimal(productData[i].A03A08A07Amount)
          productData[i].A03A08A08Premium =  toDecimal(productData[i].A03A08A08Premium)
          productData[i].A03A08A08Amount =  toDecimal(productData[i].A03A08A08Amount)
          productData[i].HJPremium = toDecimal(productData[i].HJPremium)
          productData[i].HJAmount = toDecimal(productData[i].HJAmount)
        }

        return productData;
      },

      getMoney(resultData, code){
        for(let i=0; i<resultData.length; i++){
          if(resultData[i].insuranceTypeCode == code){
            return resultData[i];
          }
        }
        //没有找到返回null
        return null;
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>
